module.exports = __webpack_public_path__ + "img/13-Kinzoku Sangyo Shimbun.037ffeb6.png";